import type { PostTablesLabels200DataItem } from '@ipfabric/api-client/client/schemas/postTablesLabels200DataItem';
import type { Filters, LabelTargetType } from '@ipfabric/utils';
import { resolveAssignedBySource } from 'pages/Settings/DiscoverySnapshots/DiscoveryDataEnrichment/AssignedLabels/assignedByColumn';
import {
  isAssignedLabelLinkedToRule,
  readTableCell,
} from 'pages/Settings/DiscoverySnapshots/DiscoveryDataEnrichment/AssignedLabels/assignedLabelsRow';
import type { DiscoveryDataEnrichmentLink } from 'pages/Settings/DiscoverySnapshots/DiscoveryDataEnrichment/discoveryDataEnrichmentLink';
import { formatDisplayLabel } from 'pages/Settings/DiscoverySnapshots/DiscoveryDataEnrichment/shared/formatDisplayLabel';

export type LabelAssignment = {
  assignedByLink?: DiscoveryDataEnrichmentLink;
  label: string;
  labelId: string;
  linkedToRule: boolean;
  source: 'manual' | 'auto' | 'inherited' | 'ipf';
};

export const getLabelsTargetFilter = (
  targetType: LabelTargetType,
  targetId: string,
): Filters => ({
  targetId: ['eq', `${targetType}/${targetId}`],
});

const toDisplayLabel = (row: PostTablesLabels200DataItem): string | null => {
  const label = readTableCell(row.label);
  if (label) {
    return label;
  }
  const name = readTableCell(row.name);
  if (!name) {
    return null;
  }
  return formatDisplayLabel(name, readTableCell(row.value));
};

const toSource = (
  row: PostTablesLabels200DataItem,
): 'manual' | 'auto' | 'inherited' | 'ipf' | null => {
  const source = readTableCell(row.assignment);
  if (
    source === 'manual' ||
    source === 'auto' ||
    source === 'inherited' ||
    source === 'ipf'
  ) {
    return source;
  }
  return null;
};

export const mapLabelAssignmentRow = (
  row: PostTablesLabels200DataItem,
): LabelAssignment | null => {
  const label = toDisplayLabel(row);
  const labelId = readTableCell(row.labelId);
  const source = toSource(row);
  if (!label || !labelId || !source) {
    return null;
  }
  const assignedBySource = resolveAssignedBySource(row);
  return {
    label,
    labelId,
    assignedByLink:
      assignedBySource.kind === 'link' ? assignedBySource.link : undefined,
    linkedToRule: isAssignedLabelLinkedToRule(row),
    source,
  };
};
